<template>
	<div id="Welcome">
		<div class="overlay"></div>
		<div class="ticket body row scroll-y">
			<div class="header">
				<div id="logo-bar"><img :src="logoSrc"/></div>
			</div>
			<div class="content" style="padding:0 .8em .8em .8em;">
				<div class="print-lane-bar"></div>
				<div class="title">
					<h1 style="font-size:2.3em;" class="text-shadow"><img class='road-icon drop-shadow' :src="'/images/road_icon.webp'"/> {{ priority_entry_lane }}</h1>
				</div>
				<div class="print-lane-bar"></div>
				<div class="spacer-bot-8em"></div>
				<div class="cred-details">
					<div v-if="ticket_title">
						<i class="fas fa-ticket-alt"></i> {{ ticket_title }}
					</div>
					<div v-if="lodging_title" style="padding-top:.4em;">
						<i class="fas fa-campground"></i> {{ lodging_title }}
					</div>
				</div>
				<div class="name text-shadow" style="font-size:2em;" v-html="name">
				</div>
				<div id="welcome-qrcode">
					<qrcode-vue class="rounded-corner-border" v-if="qrcode" v-bind:value="qrcode" :size=getQRCodeWidth() level="Q"></qrcode-vue>
					<div style="height:165px" v-if="!qrcode">
						<p class="text-center align-center">QR CODE NOT FOUND</p>
					</div>
				</div>
				<p>This QR code is linked to your user.<br/>Every variation is valid.</p>
				<div class="name-must-match">
					<b><p>THE NAME ABOVE & SET IN YOUR USER PORTAL MUST MATCH YOUR PHOTO GOVERNMENT ID</p></b>
				</div>
				<div class="company-name" style="font-size:1em;">{{ companyName.toUpperCase() }}</div>
			</div>
			</div>
		<div id="ControlBar" class="no-print footer row">
			<button id="printBtn" class="column" v-on:click="printWelcome"><i class="fas fa-print"></i> print</button>
			<!--			<button id="installButton"><i class="fas fa-mobile-alt"></i> mobile app</button>-->
			<!--<a class="btn" target="_blank" href="https://shambhalamusicfestival.com/how-to-install-mobile-app"><i class="fas fa-mobile-alt"></i> mobile app</a>-->
			<!-- <button v-on:click="bookmarkWelcome"><i class="fas fa-bookmark"></i> bookmark</button> -->
			<button id="forgetDevice" class="column" v-on:click="forgetDevice"><i class="fas fa-unlink"></i> forget this device</button>
		</div>
<!--		<div class="apple-users no-print"><strong>Apple Users:</strong> Choose the <strong>Share Button</strong> and then <strong>Add to Homescreen</strong> to install the App or-->
<!--			<strong>Print</strong> or <strong>Save as PDF</strong> to capture an offline copy.-->
<!--		</div>-->

		<!--
		<div class="forget-device no-print">
			<button v-on:click="returnToPortal"><i class="fas fa-home"></i> Return to Portal</button>
		</div>
		-->
	</div>
</template>

<script>
import axios from 'axios';
import QrcodeVue from 'qrcode.vue'

export default {
	name: 'Welcome',
	components: {
		QrcodeVue,
	},
	data() {
		return {
			loaded: false,
			welcome: window.welcome,
			qrcode: '',
			qrsize: '',
			barcode: '',
			user: '',
			userid: '',
			name: '',
			ticket_title: '',
			ticket_sku: '',
			ticket_claimed: false,
			ticket_is_special: false,
			ticket_color: '',
			ticket_entry_lane: '',
			// Used to display priority ticket / lodging (and lane to use)
			priority_title: '',
			priority_icon: '',
			priority_entry_lane: '',
			lodging_title: '',
			lodging_sku: '',
			lodging_claimed: false,
			lodging_color: '',
			lodging_entry_lane: '',
			logoSrc: window.logo_image_path,
			companyName: process.env.VUE_APP_COMPANY_NAME,
		}
	},
	mounted: function () {
		//Handle Redirect from User Portal, fetch user data from URL
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('crossDomainReceiver')) {
			let userData = urlParams.get('crossDomainReceiver').unPackageCrossDomain().decode().encode();
			localStorage.setItem('user', userData);

			this.user = userData;
			this.qrcode = userData;
			this.barcode = `${userData.decode().padLeft(10)}`;
			this.userid = userData.decode();
		} else {
			this.LoadCachedData();
		}
		this.LoadFreshData();
	},
	methods: {
		LoadCachedData() {
			const empty = window.helpers.empty;
			if (empty(localStorage.getItem('user'))) {
				//window.location = window.user_portal_url
			} else {
				this.user = localStorage.getItem('user');
				window.user = this.user;
				this.qrcode = localStorage.getItem('user').decode().encode();
				this.barcode = `${localStorage.getItem('user').decode().padLeft(10)}`;
				this.userid = localStorage.getItem('user').decode();
			}
			window.welcome.loaded = true;
			this.checkTicketTypeColor();
			this.loaded = true;
		},
		LoadFreshData() {
			axios.defaults.headers.common['X-Auth-Token'] = 'wuqg3scwoKqTJUybsMvWM6qKThisIsASecret'.encode();
			axios.post(`${window.welcome.api_server}/api/welcomeportal`, {
				confirm: this.user,
			})
				.then(res => {
					if (res.data.status.success) {
						const response = res.data.data;
						const empty = window.helpers.empty;

						this.name = !empty(response.name) ? response.name.decode() : '';
						this.ticket_title = !empty(response.ticket_title) ? response.ticket_title.decode() : '';
						this.ticket_sku = !empty(response.ticket_sku) ? response.ticket_sku.decode() : '';
						this.ticket_claimed = !empty(response.ticket_claimed) ? response.ticket_claimed.decode() : false;
						this.ticket_is_special = response.ticket_is_special;
						this.ticket_color = !empty(response.ticket_color) ? response.ticket_color : process.env.VUE_APP_DEFAULT_TICKET_COLOR;
						this.ticket_entry_lane = !empty(response.ticket_entry_lane) ? response.ticket_entry_lane : '';
						this.lodging_title = !empty(response.lodging_title) ? response.lodging_title.decode() : '';
						this.lodging_sku = !empty(response.lodging_sku) ? response.lodging_sku.decode() : '';
						this.lodging_claimed = !empty(response.lodging_claimed) ? response.lodging_claimed.decode() : false;
						this.lodging_color = !empty(response.lodging_color) ? response.lodging_color : '';
						this.lodging_entry_lane = !empty(response.lodging_entry_lane) ? response.lodging_entry_lane : '';

						// No ticket, alert and close tab
						if (empty(response.ticket_sku)) {
							window.debug('🎟️ No Ticket Found');
							alert("You need a claimed ticket to enter the festival, please claim your ticket in the user portal.");
							window.close();
						}

						this.checkTicketTypeColor();
					} else {
						window.debug('📡DataConnect: 🚫Remote Not Retrieved');
						alert("we dont't have a valid login -  try again.");
						alert("You need a claimed ticket to enter the festival, claim your ticket or login and claim it again.");
						window.close();
					}
				})
				.catch(err => {
					window.debug('📡DataConnect: 🚫Error Connecting to Server');
					window.debug(err);
					alert("Something went wrong while fetching the your data, please check your connection.")
				});
			window.debug('📡DataConnect: Finished Loading Fresh Data');
		},
		checkTicketTypeColor() {
			// Some ticket types should not be allowed through GA. Ie crew, artists, vendors, etc.
			this.priority_title = this.ticket_title;
			this.priority_icon = 'fas fa-ticket-alt';
			this.priority_entry_lane = this.ticket_entry_lane;
			if (this.ticket_is_special === true) {
				document.documentElement.style.setProperty('--pass-color', this.ticket_color);
			} else if (this.lodging_color) {
				document.documentElement.style.setProperty('--pass-color', this.lodging_color);
				this.priority_icon = 'fas fa-campground';
				this.priority_title = this.lodging_title;
				this.priority_entry_lane = this.lodging_entry_lane;
			} else if (this.ticket_color) {
				document.documentElement.style.setProperty('--pass-color', this.ticket_color);
			} else {
				// Set GA ticket color
				document.documentElement.style.setProperty('--pass-color', process.env.vue_app_default_ticket_color);
			}
			// Set font & logo color based on pass-color
			const fontColor = this.getFontColor(this.ticket_color);
			document.documentElement.style.setProperty('--font-color', fontColor);
			document.documentElement.style.setProperty('--logo-color', fontColor);
			
		},
		printWelcome() {
			window.print();
			return false;
		},
		forgetDevice() {
			localStorage.clear();
			this.returnToPortal();
		},
		returnToPortal() {
			window.location = window.user_portal_url;
		},
		hexToRgb(hex) {
		// Remove the hash at the start if it's there
		hex = hex.replace(/^#/, '');

		// Parse the r, g, b values
		let bigint = parseInt(hex, 16);
		let r = (bigint >> 16) & 255;
		let g = (bigint >> 8) & 255;
		let b = bigint & 255;

		return [r, g, b];
		},
		getLuminance(r, g, b) {
			const rgb = [r, g, b].map((c) => {
				c /= 255;
				return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
			});
			return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
		},
		getFontColor(hex) {
			// lint errors next 3 lines - uncomment when needed to switch font color - once we figure out logic for images on iphone
			console.log('Background-hex: ' + hex);
			/*
			const [r, g, b] = this.hexToRgb(hex);
			const luminance = this.getLuminance(r, g, b);
			*/
			return 'white';
			// Figure this out when we need it
			//return luminance > 0.2 ? 'black' : 'white';
		},
		getQRCodeWidth() {
			const width = window.innerWidth;
			return width < 450 ? width / 1.6  : 250;
		},
	},

}
</script>

<style>
/* libre-barcode-39-extended-regular - latin */
@font-face {
	font-family: 'Libre Barcode 39 Extended';
	font-style: normal;
	font-weight: 400;
	src: url('/fonts/libre-barcode-39-extended-v7-latin-regular.eot'); /* IE9 Compat Modes */
	src: local('Libre Barcode 39 Extended'), local('LibreBarcode39Extended-Regular'),
	url('/fonts/libre-barcode-39-extended-v7-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('/fonts/libre-barcode-39-extended-v7-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */ url('/fonts/libre-barcode-39-extended-v7-latin-regular.woff') format('woff'), /* Modern Browsers */ url('/fonts/libre-barcode-39-extended-v7-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */ url('/fonts/libre-barcode-39-extended-v7-latin-regular.svg#LibreBarcode39Extended') format('svg'); /* Legacy iOS */
}

/* libre-barcode-39-extended-text-regular - latin */
@font-face {
	font-family: 'Libre Barcode 39 Extended Text';
	font-style: normal;
	font-weight: 400;
	src: url('/fonts/libre-barcode-39-extended-text-v7-latin-regular.eot'); /* IE9 Compat Modes */
	src: local('Libre Barcode 39 Extended Text'), local('LibreBarcode39ExtendedText-Regular'),
	url('/fonts/libre-barcode-39-extended-text-v7-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('/fonts/libre-barcode-39-extended-text-v7-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */ url('/fonts/libre-barcode-39-extended-text-v7-latin-regular.woff') format('woff'), /* Modern Browsers */ url('/fonts/libre-barcode-39-extended-text-v7-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */ url('/fonts/libre-barcode-39-extended-text-v7-latin-regular.svg#LibreBarcode39ExtendedText') format('svg'); /* Legacy iOS */
}

/* #### Main CSS Variables #### */
:root {
	/*
	--pass-color: #966dff;
	*/
}

body {
	margin: 0;
	font-family: 'Raleway', Tahoma, Verdana, sans-serif;
	font-size: 16px;
	font-weight: normal;
}

h1, h2, h3, h4, h5, h6 {
	font-family: 'Oswald', Tahoma, Verdana, sans-serif;
	line-height: 1.4;
	font-weight: bold;
	letter-spacing: normal;
}

#logo-bar img {
	/*
	doesn't work on safari
	filter: drop-shadow(0px 1000px 0 var(--logo-color));
	transform: translateY(-1000px);
	*/
	width: 260px;
	height: 78px;
	padding-top:1em;
}

#welcome-qrcode canvas {
	border-radius: 1em; /* Adjust the value to round the corners */
	border:solid white 1.3em !important;
	margin-bottom: -.25em;
	box-shadow: .3em .3em .5em rgba(0, 0, 0, 0.5); /* Adjust the shadow properties as needed */
}

.rounded-corner-border {
	/* this doesn't work on iphone
	margin: auto;
	width: fit-content;
	--s: 50px; /* the size on the corner */

	/*
	padding: 0; /* the gap between the border and image */
	/*
	border: .5em solid black; /* the thickness and color */
	/*
	border-radius: 1em;
	-webkit-mask:
			conic-gradient(at var(--s) var(--s),#0000 75%,#000 0)
			0 0/calc(100% - var(--s)) calc(100% - var(--s)),
			linear-gradient(#000 0 0) content-box;
	*/
}

#ControlBar {
	width: 100%;
	max-width: 450px;
	text-align: center;
	padding: 0 0 .5em 0;
	justify-content: center;
	border-top:2px solid var(--font-color);
	background-color: var(--pass-color);
}

#ControlBar #printBtn {
	float: left;
}

#ControlBar #forgetDevice {
	float: right;
}

button, a.btn {
	border: 0;
	border-radius: .5em;
	display: inline-block;
	padding: 10px 15px;
	margin: 10px;
	color: var(--pass-color);
	background: var(--font-color);
	text-transform: uppercase;
	text-decoration: none;
	font-size: 12px;
}

button:hover {
	cursor: pointer;
}

@media only print {
	.no-print {
		display: none !important;
	}
}

@media all and (display-mode: standalone) {
	#installButton {
		display: none !important;
	}
}

//--------------- new code
body {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	background-color: #f3f3f3;
	font-family: Arial, sans-serif;
	margin: 0;
}

#Welcome {
	height: 100vh;
	width: 100%;
	max-width: 450px;
	background-color: var(--pass-color);
	color: var(--font-color);
	overflow: hidden;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.overlay {
	position: absolute;
	top: 6em;
	left: 0;
	width: 100%;
	height: calc(100vh - 6em);
	max-width: 450px;
	background-image: url('/images/overlay_grey.webp');
	background-repeat: no-repeat !important;
	background-size: cover;
	opacity: 0.5;
	/*
	Not working with safari
	filter: drop-shadow(0px 500em 0 var(--logo-color));
	transform: translateY(-500em);
	*/
}

.header {
	align-items: center;
	padding: 10px;
}

.logo img {
	height: 30px;
}

.spacer-bot-8em {
	padding-bottom: .8em;
}

.title h1 {
	margin: 10px 0;
	font-size: 22px;
}

.details {
	padding: 10px;
}

.details p {
	margin: 5px 0;
	font-size: 14px;
}

.icon {
	margin-right: 5px;
}

.name, .title, .cred-details {
	overflow-wrap: break-word;
}

.name-must-match p {
	border-top: 1px solid var(--font-color);
	padding-top: 1em;
	padding-bottom: .2em;
	font-size: .9em;
}

.ticket-number p {
	margin: 10px 0;
	font-size: 12px;
}

.cred-details {
	padding: .5em;
}

.name {
	padding: .5em;
}

.road-icon {
	width: .5em;
	height: .7em;
}

.drop-shadow {
	box-shadow: 3px 3px 1px rgba(0, 0, 0, 0.5); /* Adjust the shadow properties as needed */
}

.text-shadow {
	text-shadow: 3px 3px 1px rgba(0, 0, 0, 0.5); /* Adjust the shadow properties as needed */
}

.company-name{
	padding: 1em 0;
	margin: .2em 0 0 0;
	border-top:1px solid var(--font-color);
}

@media screen {

	/* start of screen rules. */

	/* Generic pane rules */
	body { margin: 0;}
	.row, .col { position: absolute; max-width: 450px;}
	.row { left: 0; right: 0; }
	.col { top: 0; bottom: 0; }
	.scroll-x { overflow-x: auto; }
	.scroll-y { overflow-y: auto; }

	.body.row { top: 0px; bottom: 50px; }
	.footer.row { height: 50px; bottom: 0; }

	/* end of screen rules. */
}

@media print {
	:root {
		--font-color: #000000 !important; /* Black for printing */
		color: black !important;
	}
	
	#Welcome {
		transform: scale(0.85);
		max-width: 4.5in;
		min-height: 7in;
	}
	
	* {
		-webkit-print-color-adjust: economy;
		print-color-adjust: economy;
	}
	
	.drop-shadow, .text-shadow, #welcome-qrcode canvas {
		box-shadow: none !important;
		text-shadow: none !important;
	}
	
	img {
		filter: invert(1);
	}
	
	#Welcome, #ControlBar {
		background-color: transparent !important;
	}
	
	.overlay {
		display: none !important;
	}

	.print-lane-bar {
		height: .15in;
		background-color: var(--pass-color) !important;
		-webkit-print-color-adjust: exact; /* Chrome, Safari */
		color-adjust: exact; /* Firefox */
		print-color-adjust: exact; /* Standard */
	}
}

</style>

